<template>
  <div class="subPage_container" style="padding-top: 20px">
    <div>
      <div v-if="processedBriefList.length > 0 && loadBrief" class="Tb_data_briefing">
        <ul>
          <li
            v-for="(briefTitle, index) in processedBriefList"
            :key="index"
            @click="goDetail(briefTitle.id, briefTitle.language)"
          >
          <div class="brief-ai-top">
            <div class="ai-top-left">
              <img src="@/assets/images/brief/briefing.png" alt="icon" />
              <h2>{{ briefTitle.date }} AI {{ $t("brief['brief']") }}</h2>
            </div>
            <div class="ai-top-right">
              <img v-if="briefTitle.isToday" src="@/assets/images/brief/brief-active.png" alt="icon" />
              <img v-else src="@/assets/images/brief/brief.png" alt="icon" />
            </div>
          </div>
          <div class="row-line"></div>
          <div class="brief-ai-bottom">
            <p style="text-align: right;">{{ briefTitle.date }} {{ briefTitle.time }} (UTC)</p>
            {{ getLangText(briefTitle.language) }}
          </div>
          </li>
        </ul>
      </div>

      <div v-if="processedBriefList.length === 0 && loadBrief" class="Tb_data_briefing">
        <div class="nodata_com">{{ $t("brief['noData']") }}</div>
      </div>
    </div>

    <div class="Tb_data_briefing" v-if="!loadBrief">
      <div class="loading_spinner_trade">
        <div class="loading_circle_trade"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.params.currentTab === "pm-brief") {
        vm.$store.commit("board/setTimetype", "PM");
        vm.$store.commit("board/changeTab", "pm-brief");
      }
    });
  }
};
</script>

<script setup>
import { computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import { getCurrentLocaleTimeHour } from "@/utils/localeTime";

import "@/assets/css/board.css";

const store = useStore();
const router = useRouter();
const nowTime = getCurrentLocaleTimeHour();

const todayFormatted = computed(() => {
  if (!nowTime || !nowTime.Date) return "";
  // "2026-07-06" -> "2026.07.06" 으로 변환
  return nowTime.Date.replace(/-/g, ".");
});

// ==========================================
// 1. Vuex State (computed로 연결)
// ==========================================
const currentTab = computed(() => store.state.board.currentTab);
const originalBriefList = computed(() => store.state.board.aiBriefTitleList);
const timetype = computed(() => store.state.board.timetype);
const loadBrief = computed(() => store.state.board.loadBrief);

const processedBriefList = computed(() => {
  if (!originalBriefList.value || originalBriefList.value.length === 0) return [];
  
  return originalBriefList.value.map(item => {
    // item.title (예: "2026.07.06 00:18") 에서 앞의 날짜 부분만 자릅니다.
    // ※ 만약 데이터 속성명이 title이 아니라 date라면 item.date.split... 으로 변경하세요!
    const itemDate = item.title ? item.title.split(" ")[0] : "";
    
    return {
      ...item,
      // 오늘 날짜와 일치하면 true, 아니면 false
      isToday: itemDate === todayFormatted.value 
    };
  });
});

// ==========================================
// 2. Vuex Mutations & Actions 매핑 함수
// ==========================================
const changeLoadBrief = (payload) => store.commit("board/changeLoadBrief", payload);
const changeLoadAi = (payload) => store.commit("board/changeLoadAi", payload);
const langClick = (payload) => store.commit("board/langClick", payload);
const getAibriefTitleList = () => store.dispatch("board/getAibriefTitleList");

// ==========================================
// 3. 템플릿용 유틸리티 로직 (언어 변환 리팩토링)
// ==========================================
const languageMap = {
  korea: "한국어",
  japan: "日本語",
  chinese: "中文",
  english: "English",
  vietnam: "Tiếng Việt"
};

// 매핑된 언어가 없으면 본래 영어 텍스트를 그대로 반환합니다.
const getLangText = (lang) => languageMap[lang] || lang;

// ==========================================
// 4. Methods
// ==========================================
const goDetail = (id, lang) => {
  router.push(`${currentTab.value}?id=${id}&lang=${lang}`);
};

// ==========================================
// 5. Watchers
// ==========================================
watch(currentTab, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    changeLoadBrief({ state: false });
  }
  langClick({ state: false });
});

watch(timetype, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    getAibriefTitleList();
  }
});

// ==========================================
// 6. Lifecycle Hooks (created + mounted 통합)
// ==========================================
onMounted(async () => {
  // 기존 created() 에 있던 로직
  changeLoadBrief({ state: false });
  
  // 기존 mounted() 에 있던 로직
  await getAibriefTitleList();
  changeLoadAi({ state: false });
});

</script>

<style scoped>


#market_type a {
  min-width: 70px;
}

.loading_spinner_trade {
  margin: auto;
  text-align: center;
  padding-left: 15px;
}

.loading_circle_trade {
  margin: 50px auto;
  width: 40px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, var(--primary-color) 94%, #0000) top / 8px 8px no-repeat,
    conic-gradient(#0000 30%, var(--primary-color));
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: load 1.5s linear infinite;
}

.loading_spinner {
  margin: auto;
  text-align: center;
  padding-top: 100px;
}

.loading_circle {
  margin: 0 auto;
  width: 60px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, var(--primary-color) 94%, #0000) top / 8px 8px no-repeat,
    conic-gradient(#0000 30%, var(--primary-color));
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: load 1.5s linear infinite;
}

@keyframes load {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>